import account from './account';

export default {
  account: {
    pages: {
      ...account,
      // organization: {
      //   title: 'Información General',
      // },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/account/index.js